import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
  title1: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
  company: '大和ハウスフィナンシャル株式会社',
  introduction_text:
    '大和ハウスフィナンシャル株式会社様のスマホアプリ「HeartOneポータルアプリ」の企画・開発を担当しました。このアプリは「グループ内外のお客様をつなぐDX推進施策」として、お客様をサポートする仕組みの最初のステップです。弊社はプロダクトマネジメントからデザイン、開発まで一貫して実施しました。',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  tag4text: 'ZEBRA',
  tag4src: '/cases/zebra/',
  industryTagText: '金融/不動産',
  industryTagSrc: '/cases/finance/',
  image: '/images/img/cases/heart-one/mv.webp',
  movie: '',
  alt: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
}

// プロジェクト概要
export const overviewTitle = '大和ハウスグループのカード戦略を支える新アプリ'

export const overviewItem: OverviewItems[] = [
  {
    text: '少子高齢化や働き方の多様化など、人々のライフスタイルが大きく変化する中、企業と顧客の関係づくりも日々進化を求められています。大和ハウスフィナンシャルでは、グループ各社との連携を強化し、お客様を一元的につなぐことを目指し「HeartOneポータルアプリ」の開発に着手しました。',
  },
  {
    text: '実は、これまでもアプリの開発を検討していましたが、複数回にわたって頓挫していました。その理由のひとつに、顧客接点の分散や、LINEやメールといったコミュニケーションツールの活用が主流であったことが挙げられます。しかし、社内で「お客様とより密な関係を築く仕組みが必要」という共通認識が生まれ、遂に本格的なアプリ開発に踏み切ることになりました。',
  },
  {
    text: 'その際、過去のシステム最適化で実績のあったアイスリーデザインに声がかかり、プロダクトマネジメントから開発・運用提案までを一気通貫で支援させていただくことになりました。',
  },
  {
    text: '本記事では、大和ハウスフィナンシャルのカード戦略課の皆様と、アイスリーデザイン担当メンバーへのインタビューを通して、「HeartOneポータルアプリ」がどのように誕生したのか、その舞台裏に迫ります。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '顧客接点の分散と一方通行のコミュニケーション',
        text: 'メールやSNSなど複数のチャネルに分散しており、ユーザーに合わせた情報を届けにくい。',
      },
      {
        title: 'スマホアプリ開発の不慣れ',
        text: '大和ハウスフィナンシャル様として初めての本格的なスマホアプリ開発で、ノウハウが不足していた。',
      },
      {
        title: '中長期的なグループ展開への対応',
        text: '将来的に大和ハウスグループ各社・外部サービスとの連携を見据えた柔軟なアプリ基盤が必要。',
      },
    ],
    solutions: [
      {
        title: 'プロダクトマネジメントと要件整理',
        text: '「実現したいこと」が多岐にわたる中、優先順位をつけてコア機能を明確化。リリーススケジュールと運用コストを考慮した段階的な開発ロードマップを策定した。',
      },
      {
        title: 'UX/UIデザインでユーザー視点を重視',
        text: 'グループ各社やカード会員ユーザーが直感的に利用できるデザインを提案。オブジェクト指向UIなどを用い、分かりやすさと親しみやすさを両立した。',
      },
      {
        title: 'スマホアプリ開発＆海外プラットフォーマー対応',
        text: 'Apple・Googleとの申請業務で深夜対応が必要な場面も粘り強くサポート。デジタルカードなどセンシティブ情報を扱う機能でも、セキュリティ要件を満たす設計を実現。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '散らばった顧客接点、アプリで一つにしませんか？',
  description:
    '要件整理から、AI駆動の開発とUX/UI設計、リリース後の継続改善まで一気通貫でご支援します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
